import { FC, useEffect } from 'react';
import { ApolloQueryResult } from '@apollo/client';

import { DiffFrag } from './Diff';
import { ReadDiffDocumentQuery } from '../../graphql/__generated__/graphql';
import { useFragment } from '../../graphql/__generated__';
import { DiffViewBaselineFragment, DiffViewFragment, DiffViewSnapshotFragment } from './DiffView';

type Props = {
  diffResult: ApolloQueryResult<ReadDiffDocumentQuery>;
}

const DiffPrefetchImage: FC<Props> = ({ diffResult }) => {
  const diff = useFragment(DiffFrag, diffResult.data?.diff);
  const diffView = useFragment(DiffViewFragment, diff);
  const snapshot = useFragment(DiffViewSnapshotFragment, diffView?.snapshot);
  const baseline = useFragment(DiffViewBaselineFragment, diffView?.baseline);

  useEffect(() => {
    const getImage = (url: string) => {
      const img = new Image();
      img.src = url;
    };

    if (baseline?.imageUrl) getImage(baseline.imageUrl);
    if (snapshot?.imageUrl) getImage(snapshot.imageUrl);
  }, [diffResult]);

  return null;
};

export default DiffPrefetchImage;
